import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FileInputValueModel, InputValidationErrors } from '@libs/form/models';

export class FileCountValidator {
  public static minCount(min: number): ValidatorFn {
    return (control: AbstractControl<FileInputValueModel[] | null>): InputValidationErrors | null => {
      const count: number = Array.isArray(control.value) ? control.value.length : 0;

      if (count > 0 && count < min) {
        return { fileMinCount: true };
      }

      return null;
    };
  }
}
